import { render, staticRenderFns } from "./perintahKerja.vue?vue&type=template&id=5ec991b4"
import script from "./perintahKerja.vue?vue&type=script&lang=js"
export * from "./perintahKerja.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports